import React from 'react';
import { AppsContext, useAppsProvider } from './manifest/useApps';
import IframeHost from './Extensions/IframeHost';

var AppsContextProvider = function AppsContextProvider(_ref) {
  var children = _ref.children;
  var apps = useAppsProvider();
  return React.createElement(AppsContext.Provider, {
    value: apps
  }, React.createElement(IframeHost, null), children);
};

export default AppsContextProvider;